import styled from 'styled-components';

const MaintenanceWrapper = styled.div`
  background: url('https://minio-console.ext.np.renewables-apps.com/api/v1/buckets/cosmos-test/objects/download?preview=true&prefix=Y29zbW9zL0Nvc21vcy9hc3NldHMvd2luZHBhcmsuanBn&version_id=null');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  position: fixed;
  width: 100%;
  height: 100%;

  font-family: sans-serif;
`;

const Card = styled.div`
  background: #ffffff;
  color: #3ed8c3;
  padding: 1.25rem;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  max-width: 500px;
  text-align: center;
`;

const MaintenanceTitle = styled.h1`
  font-size: 2rem;
  margin-bottom: 1rem;
  color: #3ed8c3;
`;

const MaintenanceText = styled.p`
  font-size: 1.1rem;
  color: #3ed8c3;
`;

const MaintenancePage = () => (
  <MaintenanceWrapper>
    <Card>
      <MaintenanceTitle>🚧 Under Maintenance</MaintenanceTitle>
      <MaintenanceText>
        We're currently performing some updates. Please check back later.
      </MaintenanceText>
    </Card>
  </MaintenanceWrapper>
);

export default MaintenancePage;
